import * as Configuration from '../app.constants.js';

trackerSetupConfig.$inject = ['$httpProvider', '$urlRouterProvider', '$provide'];
export function trackerSetupConfig($httpProvider, $urlRouterProvider, $provide) {

  $provide.decorator('$exceptionHandler', ['$delegate', '$injector', function($delegate, $injector) {
    // Note: we use $injector here because if we do not, we get a circular dependency
    return function (exception, cause) {
      try {
        $delegate(exception, cause);
        let XHRStatsFactory = $injector.get('XHRStatsFactory');
        XHRStatsFactory.onException(exception, cause);
      } catch (e) {
        console.error(e);
      }
    };
  }]);

  $httpProvider.interceptors.push(['$q', 'XHRStatsFactory', function($q, XHRStatsFactory) {
    return {
      'request': function(config) {
        try { XHRStatsFactory.onHttpRequest(config); } catch (e) { console.error(e); }
        return config;
      },
      'requestError': function(rejection) {
        try { XHRStatsFactory.onHttpRequestError(rejection); } catch (e) { console.error(e); }
        return $q.reject(rejection);
      },
      'response': function(response) {
        try { XHRStatsFactory.onHttpResponse(response); } catch (e) { console.error(e); }
        return response;
      },
      'responseError': function(rejection) {
        try { XHRStatsFactory.onHttpResponseError(rejection); } catch (e) { console.error(e); }
        return $q.reject(rejection);
     }
   };
  }]);
}
